export const REPORT_PAGE_SIZE = 20

export interface PaginatedReportResult<T> {
  records: T[]
  page: number
  pageSize: number
  totalRecords: number
  totalPages: number
}
